import { TeamService } from '@modules/team/team-service';
import Errors from '@shared/error/errors';
import ManageModel from '@shared/manage/manage-model';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import { routerAsync } from '@/app-module';


export default {
  namespaced: true,

  state: {
    teams: {},
    loading: false,
  },

  getters: {
    teams: state => state.teams,
    loading: state => state.loading,
  },

  mutations: {
    TEAMS_STARTED(state) {
      state.teams = {};
      state.loading = true;
    },
    TEAMS_SUCCESS(state, payload) {
      state.teams = payload;
      state.loading = false;
    },
    TEAMS_ERROR(state) {
      state.teams = {};
      state.loading = false;
    },
  },

  actions: {
    async doFind({ commit, rootGetters }, teamId) {
      try {
        commit('TEAMS_STARTED');

        const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage).getManageModel();
        const teams = await TeamService.find(teamId, manageInput);

        commit('TEAMS_SUCCESS', teams);
      } catch (error) {
        Errors.handle(error);
        commit('TEAMS_ERROR');
      }
    },

    async doUnmatch({ rootGetters }, { teamId, schoolId } ) {   
      try {
        const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage).getManageModel();
        await TeamService.unmatch(teamId, schoolId, manageInput);

        Message.success(i18n('entities.team.update.success'));
        
        // Go back
        routerAsync().go(-1);
      } catch (error) {
        Errors.handle(error);
      }
    },
  }
};